var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rootLoading)?_c('div',{staticClass:"text-center py-5"},[_c('BSpinner',{attrs:{"variant":"primary"}})],1):_c('TrendCanvas',{attrs:{"data":_vm.data,"from-x":_vm.fromX,"from-y":_vm.fromY,"request":_vm.requestData}})
}
var staticRenderFns = []

export { render, staticRenderFns }